<template>
    <footer>
        <span>Copyright © Sonja Roef 2013 All Rights Reserved. No part of this website may be reproduced without Sonja Roef's express consent.</span>
        <span>designed by Jaak Mannon</span>
</footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang='scss'>
    footer {
        padding: 20px;
        border-top: 1px solid #eee;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        font-size: 10px;
    }
</style>
